// components/Forms/WrapFormControlLabel.js
import React from "react";
import { FormControlLabel, Typography } from "@mui/material";

// Helper to determine the ARIA role based on whether it's a multi-select or single-select
export const getAriaRole = (values, keyText, fieldName) => {
  if (Array.isArray(values[fieldName])) {
    return "checkbox";
  }
  return "radio";
};

export const WrapFormControlLabel = ({
  keyText,
  textLabel,
  ControlIcon,
  ActiveControlIcon,
  selected,
  textClass = '',
  handleClick,
  ariaRole
}) => {
  const handleKeyDown = (event) => {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      handleClick(event);
    }
  };

  return (
    <FormControlLabel
      value={keyText}
      htmlFor={String(keyText)} // Ensure htmlFor is a string and matches the id
      className={`form-icon lf-icon-control-label ${keyText === textLabel ? keyText : `${textLabel} ${keyText}`} ${selected ? "selected-border" : ""}`}
      control={
        <div
          id={String(keyText)} // Ensure id is a string and matches htmlFor
          className="custom-img-wrapper"
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          tabIndex="0"
          role={ariaRole}
          aria-checked={selected}
          aria-label={textLabel}
        >
          {selected ? (
            ActiveControlIcon ? <ActiveControlIcon className="custom-img" alt={textLabel} /> : <ControlIcon className="custom-img with-border" alt={textLabel} />
          ) : (
            <ControlIcon className="custom-img" alt={textLabel} />
          )}
        </div>
      }
      label={
        <Typography
          variant="body4"
          className={`image-wrapper-label-text ${textClass} ${selected ? "selected" : ""}`}
        >
          {textLabel}
        </Typography>
      }
      labelPlacement={"bottom"}
      sx={{
        ml: 0,
        width: "85px",
        textAlign: "center"
      }}
    />
  )
}
